'use client';

import React, { useState, useEffect } from 'react';

export function ScrollProgressBar() {
  const [scrollPercent, setScrollPercent] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      if (totalScroll > 0) {
        const currentScroll = window.scrollY;
        const percent = (currentScroll / totalScroll) * 100;
        setScrollPercent(percent);
      } else {
        setScrollPercent(0); // Handle case where there is no scrollable content
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Initial calculation in case the page doesn't start at the top
    handleScroll();

    // Cleanup listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className="single-page-scroller"
      style={{ width: `${scrollPercent}%` }}
    />
  );
}